import styled from "styled-components";
import { color } from "../../../../../shared/styles";
import { IconButton } from "@mui/material";

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  gap: 0;
  flex: 1 0 0;
  align-self: stretch;
  background-color: ${color.emphasis.NEUTRAL_N0};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
`;

const SECONDARY_CHARCOAL = "var(--Secondary-Charcoal-S100, #333739)";

// Base components
const BaseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const StyledAddButton = styled(BaseButton)`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  color: ${color.primary.BLUE_B100};
  font-size: 16px;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`;

export const AddButtonText = styled.span`
  color: ${SECONDARY_CHARCOAL};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const DeleteButton = styled(IconButton)`
  align-self: flex-end;
  position: absolute;
  bottom: 16px;
  right: 36px;
  z-index: 1;

  &:disabled {
    opacity: 0.2;
  }

  &:not(:disabled) {
    opacity: 1;
    cursor: pointer;
  }
`;

export const AddButton = styled.button`
  align-self: flex-end;
  position: absolute;
  right: 24px;
  z-index: 1;
`;

export const WarningContactPerson = styled.div`
  color: #0058A0;
  font-size: 13px;
  margin: 0 20px;
  padding: 0 20px;
`;
